<soft-input
  placeholder="{{
        '#APPLICATION.FILTER_AND_SORT.PLACEHOLDER' | translate
      }}"
  [value]="searchTerm()"
  (valueChange)="onInput($event ?? '')">
  <div class="cursor-pointer select-none"
       [class.text-lighter]="!options().caseSensitive"
       (click)="onOptionsClick('caseSensitive')">Cc</div>
  <div class="cursor-pointer select-none ml-2"
       [class.text-lighter]="!options().wholeWord"
       (click)="onOptionsClick('wholeWord')">W</div>
  <div class="cursor-pointer select-none ml-2"
       [class.text-lighter]="!options().regex"
       (click)="onOptionsClick('regex')">.*</div>
</soft-input>
